//@flow

import React, { Component } from 'react';
import { Button } from 'reactstrap';

import config from '../../config';

type Data = {
  email: string,
  accessToken: string,
  provider: string,
};

type State = { isSdkLoaded: boolean };

type Props = {
  submit: (data: Data) => void,
  loading: boolean,
  buttonText: string,
};
export default class FacebookLogin extends Component<Props, State> {
  static defaultProps = {
    buttonText: 'Sign up with Facebook',
  };

  state = { isSdkLoaded: false };

  signIn = () =>
    window.FB &&
    window.FB.login(
      response => {
        if (response.status === 'connected') {
          const accessToken = response.authResponse.accessToken;

          window.FB.api('/me', { fields: 'email,name,picture' }, response =>
            this.props.submit(this.makeApiData(response, accessToken))
          );
        }
      },
      { scope: 'email,public_profile' }
    );

  makeApiData = ({ email }: string, accessToken: string) => ({
    email,
    accessToken,
    provider: 'facebook',
  });

  render() {
    return (
      <Button
        color="fb-login"
        className={this.props.loading ? 'btn-login btn-loading btn-fw' : 'btn-fw'} //For loading animations
        onClick={this.signIn}
        disabled={!this.state.isSdkLoaded}
      >
        {this.props.buttonText}
      </Button>
    );
  }

  componentDidMount() {
    const isFbSdkLoaded = !!document.getElementById('facebook-jssdk');

    if (isFbSdkLoaded) {
      this.setState({ isSdkLoaded: true });

      return;
    }

    this.loadFacebookSdk();
  }

  loadFacebookSdk = () => {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: config.facebook,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v2.11',
      });

      // change the state when FB object is ready
      this.setState({ isSdkLoaded: true });
    };

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  };
}



// WEBPACK FOOTER //
// ./src/components/Login/FacebookLogin.jsx